import React from "react";
import { IconTick } from "@ui/icons";
import Container from "@ui/container";

const SucceedStatus = () => {
    return (
        <div className="bg-[#027CC2] bg-opacity-20 text-skin-primary rounded-full p-2 pb-3 w-[30px] h-[30px] inline-block">
            <IconTick className="w-4 h-4" />
        </div>
    );
};

// TODO: we will add other status e.g failed when required
const StatusSignWidget = ({ data }) => {
    const { status } = data;
    return (
        <Container>{status === "Succeed" ? <SucceedStatus /> : null}</Container>
    );
};

export default StatusSignWidget;
